module.exports = __webpack_public_path__ + "static/media/hya-success.95f79552.svg";